import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getStockData } from '../../../../../../../../services/api';
import DataBox from './dataBox/';

class CattleStocks extends React.PureComponent {
    static propTypes = {
        isOpen: PropTypes.bool,
    };

    state = {
        dataStock: [
            {
                title: '沪市',
                code: 's_sh000001',
                name: '上证指数',
                url: '//finance.ifeng.com/app/hq/stock/sh000001/',
                img: '//x0.ifengimg.com/financeimg/astock/small/nf_sh000001.gif',
            },
            {
                title: '深市',
                code: 's_sz399001',
                name: '深证成指',
                url: '//finance.ifeng.com/app/hq/stock/sz399001/',
                img: '//x0.ifengimg.com/financeimg/astock/small/nf_sz399001.gif',
            },
            {
                title: '沪深',
                code: 's_sh000300',
                name: '沪深300',
                url: '//finance.ifeng.com/app/hq/stock/sh000300/',
                img: '//x0.ifengimg.com/financeimg/astock/small/nf_sh000300.gif',
            },
        ],
        prices: [],
        hash: '',
    };

    componentDidMount() {
        this.getData();

        this.timer = setInterval(() => {
            this.getData();
        }, 60 * 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    /**
     * 视频抓牛股数据请求
     */
    getData = async () => {
        try {
            const { dataStock } = this.state;
            const codeList = dataStock.map(item => item.code);
            const price = [];

            const data = await getStockData(codeList);

            const hash = new Date().valueOf();

            for (let a = 0; a < Object.keys(data).length; a++) {
                price.push({
                    price: data[codeList[a]][0],
                    width: data[codeList[a]][2],
                    percent: data[codeList[a]][3],
                });
            }

            this.setState({
                hash,
                prices: price,
            });
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { isOpen } = this.props;
        const { dataStock } = this.state;

        return (
            <div className={styles.box}>
                {dataStock.map((item, index) => (
                    <DataBox isOpen={isOpen} key={index} content={{ ...this.state, current: index }} />
                ))}
            </div>
        );
    }
}

export default errorBoundary(CattleStocks);
